import { useContext } from "react";
import { ImageContext } from "../components/context/image-context";
export var useImage = function useImage() {
  return useContext(ImageContext);
};